<div class="invoice-settlement"
[ngClass]="isLoading && 'text-center'">
  <i *ngIf="isLoading" class="fal fa-spinner rotate ml-2"></i>

<ng-container *ngIf="!isLoading">
  <div *ngIf="!order.isRequiredInfoMissing" class="invoice-settlement-options">
    <ng-container *ngFor="let option of settlementOptions">
      <button *ngIf="option.value !== finalizeTypes.ThirdParty" class="option-card flex-start-center"
        [disabled]="!option.active || isDisabled || order?.isThirdPartyRo"
        [ngClass]="{'active': settlementDetails?.finalizeType === option.value, 'full-paid-btn': option.value === 'fullyPaid'}"
        [pTooltip]="!isDisabled && option.disabledInfo" tooltipPosition="top"
        (click)="handleChange('finalizeType', option.value)">
        <i [class]="option.icon"></i>
        <p class="m-0">{{option.name}}</p>
      </button>

      <div class="third-part-selection" *ngIf="option.value === finalizeTypes.ThirdParty"
        [ngClass]="{'active': settlementDetails?.finalizeType === finalizeTypes.ThirdParty}">
        <app-dropdown id="settlement-option-third-party-dd" listId="settlement-option-third-party-dd-list"
          placeholder="3rd party account" leftIcon="fal fa-store" theme="border" field="name" styleClassSelectedView=""
          inactiveItemsKey="active" position="top" scrollHeight="198px" rightIcon="fal fa-check"
          styleClassDropdownListItem="text-transform-uppercase"
          [pTooltip]="!option.active && !isDisabled && option.disabledInfo"
          [disabled]="!thirdPartyAccounts?.length || !option.active || isDisabled" [fontSize]="14"
          [selectInactiveItems]="false" [options]="thirdPartyAccounts" [isDropdownIconVisible]="true"
          [setPositionDynamically]="false" [fullyControlled]="true" [value]="settlementDetails?.thirdPartyAccount"
          (appSelect)="handleChange('thirdPartyAccount', $event)">
        </app-dropdown>
      </div>
    </ng-container>
  </div>

  <!-- Commenting the Time sections -->
  <!-- <div class="invoice-settlement-date">
    <div class="date">
      <label class="font-12 font-600 mb-4px">Date</label>
      <div class="calendar-input flex-between-center payment-date pointer" [ngClass]="{'disabled-date': isDisabled}">
        <p-calendar id="settlement-date" placeholder="Date" styleClass="payment-pointer" dateFormat="M d, yy"
          [(ngModel)]="settlementDetails.date" [readonlyInput]="true" [minDate]="order?.createdAt"
          [disabled]="isDisabled" (onSelect)="handleChange('date', $event)" #paymentDateTimeEl></p-calendar>
        <i class="fal fa-calendar-alt pr-2" (click)="!isDisabled && paymentDateTimeEl.showOverlay()"></i>
      </div>
    </div>

    <div class="time">
      <label class="font-12 font-600 mb-4px">Time</label>
      <kendo-timepicker [(value)]="settlementDetails.time" popupClass="testing" [disabled]="isDisabled"
        [formatPlaceholder]="{ hour: 'hh', minute: 'mm' }">
      </kendo-timepicker>
    </div>
  </div> -->

  <ng-container *ngIf="!isFetching">
    <ng-container *ngIf="!order.isFinalized">
      <button *ngIf="!order.isRequiredInfoMissing"
        class="btn btn-primary mt-3 flex-center-center width-100p btn-confirmation"
        [pTooltip]="!settlementDetails?.finalizeType && 'Please select a finalization type'"
        [disabled]="isDisabled || isProcessing || !settlementDetails?.finalizeType || isChargeAccountPermitted() || chargreAccountLimit"
        (click)="handleSubmit()">
        Confirm finalization
        <i *ngIf="isFinalizing" class="fal fa-spinner rotate ml-2"></i>
      </button>

      <div class="mt-3 d-flex" id="post-my-fleet" *ngIf="customer?.isFleetCustomer && isMyFleetCenterEnabled
      && !order.isRequiredInfoMissing">
        <div class="d-flex">
          <app-checkbox label="" [isChecked]="postToMyFleetCenter" [fontSize]="11"
            (appChange)="onCheckboxChange($event)" tooltipIconPosition="top" tooltipStyleClass="post-my-fleet-tooltip"
            [tooltip]="getMyFleetCenterTooltip().tooltip" [disabled]="getMyFleetCenterTooltip().disabled">
          </app-checkbox>
          <div class="ml-1 font-400 font-14 font-secondary m-top-1 pointer" (click)="onCheckboxChange($event)"
            [ngClass]="{'not-allowed':getMyFleetCenterTooltip().disabled}">
            Post to MyFleetCenter
          </div>
        </div>

        <div (click)="connectToMyFleet()" class="font-primary font-14 font-600 ml-2 m-top-1 pointer"
          *ngIf="!vehicle?.isMFConnected || !customer?.isMFCustomer">
          Connect to MyFleetCenter
        </div>
      </div>

      <div class="warning-800">
        <span *ngIf="chargreAccountLimit">Outstanding balance of {{order.unpaid | currency : 'USD'}} is greater than
          remaining capacity of {{chargeAccountDetails?.availableLimit | currency : 'USD'}} on this Customer's Charge
          Account</span>
      </div>

      <div *ngIf="order.isRequiredInfoMissing" class="flex-between-center alert alert-primary p-2 mt-3">
        <div class="flex-column">
          <div>
            <i class="fal fa-exclamation-triangle mr-1" [pTooltip]="requiredInfoTooltip"></i>
            <span>Please enter missing information:</span>
          </div>
          <ul class="pl-4">
            <li *ngFor="let requirement of requirements">{{requirement}}</li>
          </ul>
        </div>
        <button class="btn btn-primary" (click)="openAuthorizationDialog()">
          Update details
        </button>
      </div>
    </ng-container>

    <p *ngIf="order.isFinalized" class="mt-3 mb-0 btn-confirmation-finalized">
      <i class="far fa-check mr-1"></i> Finalized on {{order.finalizeDate}} by {{order.finalizeBy}}
    </p>
  </ng-container>
</ng-container>

</div>
